export default [
  {
    name: "base",
    data: {},
    items: [
      {
        name: "lennaTexture",
        source: "./src/images/photo.jpg",
        type: "texture",
      },
    ],
  },
];
